<template>
  <el-card
    id="myActionPlanCard"
    v-loading="loading"
    shadow="hover"
    class="clear-card myActionPlan"
    :class="$mq"
  >
    <div
      slot="header"
      class="clearfix title defaultCursor"
    >
      <span>{{ $t('actionPlan.actionPlanProgress') }}</span>
    </div>
    <div
      class="content"
      :class="session >= 4 && stats && stats.length > 0 ? 'filledData' : ''"
    >
      <div
        v-if="!previewMode && session >= 4 && stats && stats.length > 0"
        class="charts"
      >
        <OverviewChart
          key="realAP"
          :chart-data="stats"
          type-display="small"
        />
      </div>
      <div
        v-else
        class="charts no-data"
      >
        <OverviewChart
          v-if="!isIE"
          key="dummyAP"
          :chart-data="dummy"
          type-display="small"
          class="dummyChart"
        />
        <div
          class="noDataOverlay defaultCursor"
          :class="{gray: isIE}"
        >
          {{ $t('actionPlan.noData') }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';

export default {
  components: {
    OverviewChart: () => import(/* webpackChunkName: "Charts" */ '@/views/dashboard/content/leader/actionPlan/overview/OverviewChart.vue'),
  },

  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      stats: null,
      loading: false,
      dummy: [
        {
          dummy: true,
          session_id: 'session_4',
          lga1: {
            total_avg: 0.3333,
          },
          lga2: {
            total_avg: 0.21,
          },
        },
        {
          session_id: 'session_5',
          lga1: {
            total_avg: 0.4,
          },
          lga2: {
            total_avg: 0.61,
          },
        },
        {
          session_id: 'session_6',
          lga1: {
            total_avg: 0.85,
          },
          lga2: {
            total_avg: 0.73,
          },
        },
      ],
    };
  },

  computed: {
    ...mapState({
      session: (state) => state.processStatus.process.session,
    }),

    isIE() {
      return navigator.userAgent.indexOf('MSIE') !== -1
          || navigator.appVersion.indexOf('Trident/') > -1;
    },
  },

  watch: {
    session() {
      this.getOverviewStat();
    },
  },

  created() {
    this.getOverviewStat();
  },

  methods: {
    async getOverviewStat() {
      if (this.session >= 4 && !this.stats) {
        try {
          this.loading = true;
          const response = await api.getActionPlanStat();

          const filteredList = [];
          if (response.data.length) {
            response.data.forEach((item) => {
              if (item.lga1.total_avg && item.lga2.total_avg) {
                filteredList.push(item);
              }
            });
          }

          this.stats = filteredList;
        } catch (err) {
          this.stats = [];
          // if (err.msg) {
          //   this.$message.error(err.msg);
          // }
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #myActionPlanCard {
    height: 100%;

    .title {
      text-align: center;
    }

    &:not(.mobile):not(.tablet) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 100%;
      min-height: 120px;
      align-items: center;
      font-style: italic;
      text-align: center;
      color: #c4c4c4;

      .charts {
        width: 100%;
        padding-top: 35px;
      }

      &.filledData {
        margin-left: -20px;
      }

      .no-data {
        position: relative;

        .dummyChart {
          filter: blur(2px) alpha(0.5);
          pointer-events: none;
        }

        .noDataOverlay {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          font-style: italic;
          top: 0;
          color: var(--themeFontColor);
          width: 100%;
          height: 97%;

          &.gray {
            color: #c4c4c4;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  #myActionPlanCard {
    .el-card__header {
      font-weight: bold;
    }

    &.mobile,
    &.tablet {
      .el-card__header {
        border-bottom: 0;
      }
    }
  }
</style>
